import { createRoute, type AnyRoute } from "@tanstack/react-router";
import { Scale } from "lucide-react";

import type { FeatureModule } from "@/features/types";
import { guarded } from "@/lib/auth";

import { BudgetVsActualPage } from "./pages/BudgetVsActualPage";

export interface BvaSearch {
  /** Admin tab; anything else falls back to the dashboard. */
  tab?: "access";
  /** Selected department (QB class) — opens the quick-view drawer. */
  dept?: string;
  /** "full" grows the department drawer into the expanded page view. */
  view?: "full";
  /** Fiscal year; defaults to the current year. */
  year?: number;
}

function validateSearch(search: Record<string, unknown>): BvaSearch {
  const out: BvaSearch = {};
  if (search.tab === "access") out.tab = "access";
  if (typeof search.dept === "string" && search.dept) out.dept = search.dept;
  if (search.view === "full") out.view = "full";
  const year = Number(search.year);
  if (Number.isInteger(year) && year >= 2020 && year <= 2100) out.year = year;
  return out;
}

export const budgetVsActualModule: FeatureModule = {
  key: "budget_vs_actual",
  nav: {
    label: "Budget vs Actual",
    icon: Scale,
    to: "/budget-vs-actual",
    requires: "budget_vs_actual.read",
    order: 20,
    group: "Finance",
  },
  routes: (rootRoute) => [
    createRoute({
      getParentRoute: () => rootRoute,
      path: "/budget-vs-actual",
      component: guarded("budget_vs_actual.read", BudgetVsActualPage),
      validateSearch,
    }),
  ] as unknown as AnyRoute[],
};
